import { useState, useEffect } from 'react';
import { isProductServiceAvailable } from 'src/scripts/utils/environment';

// ? [REVISIT] show alternative ways of accomplishing the same thing that would let ATC work on PLP
export const useRecommendationServiceCarousel = (productType: string, elementID: string) => {
  const [shouldShowRecommendationServiceCarousel, setShowRecommendationServiceCarousel] = useState(false);
  if (!isProductServiceAvailable) {
    console.log('Product service configuration is unavailable; that is why no Recommendation Service. Check your env');
    setShowRecommendationServiceCarousel(false);
    document.getElementById(elementID)?.remove();
  }
  const isExcludedFromCarousel = !isProductServiceAvailable;

  const initCarouselRender = (observer: IntersectionObserver) => {
    try {
      const carouselBlock: HTMLElement | null = document.getElementById(elementID);
      if (carouselBlock) observer.observe(carouselBlock);
    } catch (err) {
      document.getElementById(elementID)?.remove();
      console.log('Failed to init Recommendation Service Carousel, err: ', err);
    }
  };

  // ? [REVISIT] as people are scrollling; wouldn't this annoy them?; if they are in the test just have the componenet take up the space?
  const [oldScrollPosition, setOldScrollPosition] = useState(0);
  useEffect(() => {
    if (oldScrollPosition !== 0) {
      window.scroll(0, oldScrollPosition);
    }
    return () => {};
    // ? [REVISIT]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowRecommendationServiceCarousel]);

  useEffect(() => {
    const config = {
      root: null,
      threshold: 0.5,
    };
    const callBack: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setOldScrollPosition(window.scrollY); // Eliminate the page jump on carousel insert
          setShowRecommendationServiceCarousel(true);
          observer.disconnect();
        }
      });
    };
    const observer = new IntersectionObserver(callBack, config);
    if (!isExcludedFromCarousel) {
      initCarouselRender(observer);
    } else {
      document.getElementById(elementID)?.remove();
    }
    return () => {
      observer.disconnect();
    };
    // ? [REVISIT]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    shouldShowRecommendationServiceCarousel,
  };
};
